// extracted by mini-css-extract-plugin
export const link = "link-module--link--Wv5Wt";
export const bare = "link-module--bare--LiyCn";